import PropTypes from "prop-types";
import {
  LoaderContainer,
  LoaderContainerHorizontal,
  DotContainer,
  Dot,
  LoadingText,
  StyledBackdrop,
  StyledLinearProgress,
  StyledCircularProgress,
} from "./Loader.style";

const linearVariant = "linear";
const circularVariant = "circular";
const dotsVariant = "dots";

const Loader = ({
  show = false,
  fullScreen = true,
  loadingText = "Loading...",
  size = "small",
  variant = circularVariant,
  stackVertical = true,
}) => {
  if (!show) {
    return null;
  }

  const sizeConfig = {
    small: { spinner: 24, linear: 48, dot: 6, fontSize: 12, gap: 4 },
    medium: { spinner: 40, linear: 80, dot: 8, fontSize: 14, gap: 8 },
    large: { spinner: 50, linear: 120, dot: 10, fontSize: 16, gap: 12 },
  };

  const config = sizeConfig[size] || sizeConfig.medium;
  const spinnerSize = config.spinner;
  const linearWidth = config.linear;

  const renderIndicator = () => {
    if (variant === linearVariant) {
      return <StyledLinearProgress linearWidth={linearWidth} />;
    }
    if (variant === dotsVariant) {
      return (
        <DotContainer>
          {[0, 1, 2].map((i) => (
            <Dot key={i} dotSize={config.dot} delay={i * 0.16} />
          ))}
        </DotContainer>
      );
    }
    return <StyledCircularProgress size={spinnerSize} />;
  };

  const Container = stackVertical ? LoaderContainer : LoaderContainerHorizontal;
  const loaderContent = (
    <Container gap={config.gap}>
      {renderIndicator()}
      {loadingText && (
        <LoadingText variant="body1" fontSize={config.fontSize}>
          {loadingText}
        </LoadingText>
      )}
    </Container>
  );

  if (fullScreen) {
    return <StyledBackdrop open>{loaderContent}</StyledBackdrop>;
  }

  return loaderContent;
};

Loader.propTypes = {
  show: PropTypes.bool.isRequired,
  fullScreen: PropTypes.bool,
  loadingText: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["circular", "linear", "dots"]),
  stackVertical: PropTypes.bool,
};

export default Loader;
